import { render } from "./router-view.vue?vue&type=template&id=78294257&ts=true"
import script from "./router-view.ts?vue&type=script&lang=ts&external"
export * from "./router-view.ts?vue&type=script&lang=ts&external"

import "./router-view.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__